import { devices } from '@src/styles/theme';
import React, { Dispatch, SetStateAction, useState } from 'react';
import styled from 'styled-components';
import PpleLogo from '@src/assets/imgs/ppleLogo.png';
import Image from 'next/image';
import { navList } from '@src/data/nav';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useSetRecoilState } from 'recoil';
import keywordAtom from '@src/recoils/atom/keyword';

const NavLeft = () => {
  const router = useRouter();
  const setKeyword = useSetRecoilState(keywordAtom);

  return (
    <HeaderNavLeft>
      <HeaderUl>
        <Link
          href="/"
          style={{
            marginRight: '4rem',
          }}
        >
          <HeaderLogoIcon src={PpleLogo} alt="피플헌혈" height={25} priority />
        </Link>
        {navList.map((menu, i) => (
          <Menu isClick={menu.url === router.pathname} key={i}>
            {menu.name === '피플샵' ? (
              <a
                href={menu.url}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => {
                  sessionStorage.removeItem('community_scroll');
                }}
              >
                {menu.name}
              </a>
            ) : (
              <Link
                onClick={() => {
                  sessionStorage.removeItem('community_scroll');
                  setKeyword('');
                }}
                href={menu.url}
              >
                {menu.name}
              </Link>
            )}
          </Menu>
        ))}
      </HeaderUl>
    </HeaderNavLeft>
  );
};

const HeaderNavLeft = styled.nav`
  display: flex;
  align-items: center;
  @media ${devices.tablet} {
    width: 100%;
  }
`;

const HeaderUl = styled.ul`
  display: flex;
  position: relative;
  @media ${devices.tablet} {
    justify-content: space-between;
    width: 100%;
    align-items: center;
    padding: 0 20px;
  }
`;

const Menu = styled.li<{ isClick?: boolean }>`
  cursor: pointer;
  margin-right: 2rem;
  line-height: 28px;
  color: ${({ isClick, theme }) =>
    isClick ? theme.commonColor.pink004 : '#000'};
  font-weight: 500;
  &:hover {
    color: ${({ theme, isClick }) =>
      isClick ? theme.commonColor.pink004 : theme.commonColor.gray006};
  }
  @media ${devices.tablet} {
    display: none;
  }
`;

/** 가로형 로고(아이콘+워드마크) — 높이 기준으로 맞추고 폭은 비율대로 둔다. */
const HeaderLogoIcon = styled(Image)`
  width: auto !important;
  height: 25px !important;
  object-fit: contain;
`;

export default NavLeft;
